'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStartOfWeek = isStartOfWeek;
exports.isStartOfHour = isStartOfHour;
exports.isCurrentTimeZone = isCurrentTimeZone;
exports.isWeekend = isWeekend;
exports.containsWeekendDate = containsWeekendDate;
exports.sortTimes = sortTimes;
exports.getDateRange = getDateRange;
exports.getTimeRange = getTimeRange;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isStartOfWeek(date, includeWeekend) {
  return date.day() === (includeWeekend ? 0 : 1);
}

function isStartOfHour(date) {
  return date.minute() === 0;
}

function isCurrentTimeZone(timeZone) {
  var relativeDate = (0, _momentTimezone2.default)({
    year: timeZone.year(),
    month: timeZone.month(),
    day: timeZone.date()
  });
  return timeZone.utcOffset() === relativeDate.utcOffset();
}

function isWeekend(date) {
  return date.day() === 0 || date.day() === 6;
}

function containsWeekendDate(dates) {
  return dates.some(function (date) {
    return isWeekend(date);
  });
}

function sortTimes(times) {
  var sortedTimes = times.slice();
  sortedTimes.sort(function (a, b) {
    return a.diff(b);
  });
  return sortedTimes;
}

function range(start, end) {
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var results = [];
  for (var i = start; i < end; i += interval) {
    results.push(i);
  }
  return results;
}

function getDateRange(startDate, endDate) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      includeWeekend = _ref.includeWeekend;

  var days = Math.round(_momentTimezone2.default.duration(endDate.diff(startDate)).asDays());
  var dates = range(0, days + 1).map(function (index) {
    return (0, _momentTimezone2.default)(startDate).add({ day: index });
  });
  if (includeWeekend) {
    return dates;
  }
  return dates.filter(function (date) {
    return date.day() > 0 && date.day() < 6;
  });
}

function getTimeRange(startTime, endTime) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$interval = _ref2.interval,
      interval = _ref2$interval === undefined ? 60 : _ref2$interval;

  var minutes = _momentTimezone2.default.duration(endTime.diff(startTime)).asMinutes();
  return range(0, minutes + 1, interval).map(function (index) {
    return (0, _momentTimezone2.default)(startTime).add({ minute: index });
  });
}